import type { PowerupKind } from "./types";

export const POWERUP_COSTS: Record<PowerupKind, number> = {
  HINT: 50,
  ROWRIP: 100,
  COLCUT: 100,
  TRANSMUTE: 100,
  ZIGZAGBOLT: 200
};
